const loadVideo = {
	$play: $( '.js-video-play' ),
	$close: $( '.js-video-close' ),
};

function open( $this, $btn ) {
	if ( !$this.hasClass( 'is-active' ) ) {
		$this.addClass( 'is-active' );
		var videoId = $this.find('.js-video').data( 'target' ),
			type = $this.data( 'type' ),
			w = $this.find( '.load-image' ).outerWidth( true ),
			h = $this.find( '.load-image' ).outerHeight( true );

		var $embed = type == 'vimeo'
			? '<iframe type="text/html" width="'+w+'" height="'+h+'" src="//player.vimeo.com/video/' + videoId + '" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" wmode="transparent">'
			: '<iframe id="ytplayer" type="text/html" width="'+w+'" height="'+h+'" src="//www.youtube.com/embed/' + videoId + '?enablejsapi=1&autoplay=1&rel=0&showinfo=0&color=white&wmode=transparent" frameborder="0" wmode="transparent" allowfullscreen>';

		$this.find( '.embed' ).html( $embed );

		setTimeout( function() {
			$this.find( '.js-video' ).show();
			setTimeout( function() {
				$this.find( '.js-video' ).addClass( 'show' );
				$this.find( '.btn-play' ).fadeOut();
				$this.find('iframe')[0].src += "&autoplay=1";
			}, 10 );
			$('body').icons.init( '.svg-icon' );
		}, 600 );
	}
}

function close( $this, $close ) {
	if ( $this.hasClass( 'is-active' ) ) {
		$this.find( '.js-video' ).removeClass( 'show' );
		$this.find( '.btn-play' ).fadeIn();
		setTimeout( function() {
			$this.removeClass( 'is-active' );
			$this.find( '.embed' ).find( 'iframe' ).remove();
		}, 500 );
	}
}

loadVideo.init = function() {

	loadVideo.$play.click( function( e ) {
		e.preventDefault();
		var $this = $(this).parents( '.js-video-container' ),
			$btn = $(this);
		open( $this, $btn );
	} );

	loadVideo.$close.click( function( e ) {
		e.preventDefault();
		var $this = $(this).parents( '.js-video-container' ),
			$close = $(this);
		close( $this, $close );
	} );

};

export { loadVideo };
